import axios from "axios";
import authHeader from "../auth-header";
import { PROTOCOL, URL } from "../../utils/constants";

const API_URL = `${PROTOCOL}://${URL}/okapi/mibui/`;

export function getCurrentDagStatus(dagId) {
  return axios.get(`${API_URL}dag-logs/dag/${dagId}/current`, {
    headers: authHeader(),
  });
}
